import AdminUpdatePasein from "../../components/AdminInvoiceMedical/InvoiceMedicalUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
